// src/data/gyms/EastCoast.js
export const EastCoast = {
  id: "eastcoast",
  name: "East Coast Athletics",
  color: "#0F766E", // Teal Storm
  lightColor: "#F0FDFA",
  logo: "🌪️",

  teams: [
    { id: "breeze", name: "Breeze", level: "L2.2 Junior - PREP" },
    { id: "monsoons", name: "Monsoons", level: "L1.1 Mini - PREP" },
    { id: "tornados", name: "Tornados", level: "L1 Tiny - Novice" },
    { id: "flurries", name: "Flurries", level: "L2.2 Youth - PREP" },
    { id: "fourcast", name: "4Cast", level: "L4 Junior - Flex - D2" },
    { id: "lightning", name: "Lightning", level: "L2 Junior - D2 - Small" },
    { id: "blackice", name: "Black Ice", level: "L3 Senior Coed - D2" },
    { id: "reign", name: "Reign", level: "L4 Youth - D2" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "8:00 AM",
      teamId: "breeze",
      meet: "7:24 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "8:56 AM",
      teamId: "monsoons",
      meet: "8:20 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "9:24 AM",
      teamId: "tornados",
      meet: "8:48 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "10:09 AM",
      teamId: "flurries",
      meet: "9:33 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "10:27 AM",
      teamId: "fourcast",
      meet: "9:51 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "11:28 AM",
      teamId: "lightning",
      meet: "10:52 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "12:14 PM",
      teamId: "blackice",
      meet: "11:38 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "6:14 PM",
      teamId: "reign",
      meet: "5:38 PM",
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    // 4Cast (Row 143)
    {
      day: "Sunday",
      time: "9:00 AM",
      teamId: "fourcast",
      meet: "8:24 AM",
      panel: "Hall A",
    },

    // Lightning (Row 152)
    {
      day: "Sunday",
      time: "9:31 AM",
      teamId: "lightning",
      meet: "8:55 AM",
      panel: "Hall B",
    },

    // Black Ice (Row 164)
    {
      day: "Sunday",
      time: "10:17 AM",
      teamId: "blackice",
      meet: "9:41 AM",
      panel: "Hall A",
    },

    // Reign (Row 238)
    {
      day: "Sunday",
      time: "4:28 PM",
      teamId: "reign",
      meet: "3:52 PM",
      panel: "Hall B",
    },
  ],
};
